import { Shield, ShieldCheck, CheckCircle, Lock, Award } from 'lucide-react';
import ScrollReveal from '@/components/ScrollReveal';

const badges = [
  { label: 'DFSA Authorized', Icon: Shield },
  { label: 'ADGM FSRA Regulated', Icon: ShieldCheck },
  { label: 'ICMA Compliant', Icon: CheckCircle },
  { label: 'AML/CFT Certified', Icon: Lock },
  { label: 'ISO 27001', Icon: Award },
];

export default function TrustStrip() {
  return (
    <section className="py-8" style={{ backgroundColor: '#f4f5f7', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <ScrollReveal>
          <p className="text-center text-xs font-inter font-semibold uppercase tracking-widest mb-5" style={{ color: '#6b7280' }}>
            Regulated & Recognized By
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
            {badges.map(({ label, Icon }) => (
              <div
                key={label}
                className="flex items-center gap-2"
                data-testid={`trust-badge-${label.toLowerCase().replace(/[\s\/]/g, '-')}`}
              >
                <Icon className="w-5 h-5" strokeWidth={1.5} style={{ color: '#c9a84c' }} />
                <span className="text-sm font-inter font-medium" style={{ color: '#0a1628' }}>{label}</span>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
